import { IProduct } from 'src/@interfaces'

export enum productStatusEnum {
  promotional = 'promo',
  regular = 'regular',
}

export const productStatus = (product: IProduct) =>
  product.price !== product.discountPrice
    ? productStatusEnum.promotional
    : productStatusEnum.regular
